import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatMass } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  revised_planned_trip_fuel_burn_kg: 69000,
  revised_actual_trip_fuel_burn_kg: 67000,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  bvrColour,
  unit = "kg",
  metadata = defaultMetadata,
  industry,
  missingDataMsg,
  isExample,
}) {
  let threshold = metadata["revised_planned_trip_fuel_burn_kg"];
  let actual = metadata["revised_actual_trip_fuel_burn_kg"];

  if (!threshold || !actual) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  threshold = Number(threshold);
  actual = Number(actual);

  const data = [
    {
      name: "Expected trip fuel",
      mobileName: "Label 1",
      beforeThreshold: threshold,
      afterThreshold: 0,
      underThresholdColour:
        actual > threshold ? bvrColour.codes["200"] : bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
    {
      name: "Actual trip fuel",
      mobileName: "Label 2",
      beforeThreshold: actual > threshold ? threshold : actual,
      afterThreshold: actual > threshold ? actual - threshold : 0,
      underThresholdColour:
        actual > threshold ? bvrColour.codes["200"] : bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMin = 0;
  const margin = actual < threshold ? 0.2 * threshold : 0.2 * actual;
  const domainMax =
    actual < threshold
      ? Math.ceil((threshold + margin) / 10) * 10
      : Math.ceil((actual + margin) / 10) * 10;
  const domain = [domainMin, domainMax];

  const mobileMargin = actual < threshold ? 0.05 * threshold : 0.05 * actual;
  const mobileDomainMax =
    actual < threshold
      ? Math.ceil(threshold + mobileMargin)
      : Math.ceil(actual + mobileMargin);
  const mobileDomain = [domainMin, mobileDomainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  return (
    <BehaviourBarGraph
      data={data}
      threshold={threshold}
      thresholdLabel="Signol threshold"
      mobileDomain={mobileDomain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={actual < threshold}
      unitOfMeasure={` ${unit}`}
      axisLabel={`Fuel (${unit})`}
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={(value) =>
        `${formatMass(industry, value, 0, { boundaryValues: [0, threshold] }).formattedValue}`
      }
      isExample={isExample}
    />
  );
}
